import { MjmlAttribute } from '@wix/wix-emails-commons';
import posthtml from 'posthtml/lib';
const LINKED_TAG_MATCHERS = [{
  tag: 'mj-button'
}, {
  tag: 'mj-image'
}, {
  tag: 'a'
}];
const EDITOR_LINK_MARKERS = [MjmlAttribute.LINK_TYPE, MjmlAttribute.LINK_FILENAME, MjmlAttribute.LINK_SERVICE_ID];
const EDITOR_LINK_MARKER_PREFIX = 'data-em-link-';
export const stripEditorLinkMarkers = mjml => {
  if (!mjml.includes(EDITOR_LINK_MARKER_PREFIX)) {
    return mjml;
  }
  const plugin = tree => {
    tree.match(LINKED_TAG_MATCHERS, node => {
      for (const marker of EDITOR_LINK_MARKERS) {
        var _node$attrs;
        (_node$attrs = node.attrs) == null || delete _node$attrs[marker];
      }
      return node;
    });
    return tree;
  };
  return posthtml([plugin]).process(mjml, {
    sync: true,
    xmlMode: true
  }).html;
};
//# sourceMappingURL=strip-editor-link-markers.js.map